import { getBackendInformation } from '../BackendInformation';

import { RouteType, Route } from './types';

const standardTravelSearchAll = new Set([
    RouteType.TRAVELSEARCH_REGION,
    RouteType.TRAVELSEARCH_HOTEL,
    RouteType.TRAVELSEARCH_OFFER,
]);
const travelSearchAll = new Set([
    RouteType.TRAVELSEARCH_REGION,
    RouteType.TRAVELSEARCH_HOTEL,
    RouteType.TRAVELSEARCH_OFFER,
    RouteType.INFO_STEP35,
]);

const currentRoute = getBackendInformation<Route>()['route'];

export const isCurrentRoutePartOfString = (route: string) =>
    currentRoute.includes(route);
export const isCurrentRoute = (route: string) => currentRoute === route;
export const isPartOfRouteSet = (testSet: Set<RouteType>) =>
    testSet.has(currentRoute as RouteType);
export const isStandardTravelSearchAll = () =>
    standardTravelSearchAll.has(currentRoute as RouteType);
export const isTravelSearchAll = () =>
    travelSearchAll.has(currentRoute as RouteType);
export const isTravelBookingAll = () => currentRoute.indexOf('booking') > -1;
export const isSemPageAll = () => currentRoute.indexOf('sem_') > -1;
